import { Component, Input, OnInit } from '@angular/core';
import { InitErrors, StatePropertyValueModel } from '../shared/fs.model';
import { FileSetError, TargetType } from '../services/validation/validator.service';
import { isFileSetValid, lfFilesetLocalize } from '../shared/utils';

@Component({
  selector: 'fileset-error-messages',
  templateUrl: './error-messages.component.html',
  styleUrls: ['./error-messages.component.css']
})
export class ErrorMessagesComponent implements OnInit {
  @Input() initError: InitErrors = InitErrors.NONE;
  @Input() errors: FileSetError[];
  @Input() requiredStatus: StatePropertyValueModel;
  lfFilesetLocalizeHelper = lfFilesetLocalize;

  constructor() { }

  ngOnInit(): void {
  }

  hasValidInitError(): boolean {
    return isFileSetValid(this.initError);
  }

  hasTypeError(): boolean {
    const errors = this.errors.filter(e => e.targetType === TargetType.FileType);
    
    if (errors.length) {
      return true;
    }
    return false;
  }

  hasFileError(): boolean {
    const errors = this.errors.filter(e => e.targetType === TargetType.File);
    
    if (errors.length) {
      return true;
    }
    return false;
  }

}
